import { useFeatureToggle } from '~/platform/utilities/feature-toggles/useFeatureToggle';

/**
 * Detection seam for whether the user has submitted a 21a
 * "Apply for accreditation" application.
 *
 * TODO(139383): Replace this stub with real detection. The 21a submission
 * status needs a backend source (there is no submission field on `/user`); it's
 * being built in parallel. In-progress detection is already wired via the
 * dashboard loader from the user's `inProgressForms`, so it is not stubbed here.
 *
 * @returns {boolean}
 */
export const useHasSubmitted21aForm = () => false;

/**
 * Whether the link to the digital 21a form should be shown. Gated behind the
 * `accredited_representative_portal_form_21a` feature flag so the link is hidden
 * until the form is available in production.
 *
 * @returns {boolean}
 */
export const useShowForm21aLink = () => {
  const { useToggleValue, TOGGLE_NAMES } = useFeatureToggle();
  return useToggleValue(TOGGLE_NAMES.accreditedRepresentativePortalForm21a);
};
